import Link from 'next/link';
import { Format } from '../../../../lib/dateFns';
import utilsStyles from '../../../../styles/modules/utils.module.scss';
import { formatCurrency, formatDateCommon } from '../../../../utils/formatters';
import type { CoinHistoryItem } from '../../types';
import styles from './CoinHistory.module.scss';

type Props = {
  items: CoinHistoryItem[];
};

function CoinHistory({ items }: Props) {
  return (
    <ul className={styles.coinHistory}>
      {items.map((item) => (
        <li key={item.id} data-testid={`coin-history-item-${item.id}`}>
          <div className={styles.itemBlock}>
            <p className={`${utilsStyles.textSmall} ${utilsStyles.warmgrayColor}`}>
              {formatDateCommon(item.createdAt, Format.dateJa)}
            </p>
            <p className={styles.itemUsed}>
              利用用途
              <span className={utilsStyles.textBold} data-testid={`coin-history-item-usage-${item.id}`}>
                {item.type} / {item.subType}
              </span>
            </p>
            <div
              className={`${styles.itemCoin} ${utilsStyles.textBold}`}
              data-testid={`coin-history-item-amount-${item.id}`}
            >
              {formatCurrency(item.usedCoin)}
            </div>
            <Link
              href={`/lotteries/${item.customInfo.lotteryEventId}`}
              className={`${utilsStyles.textLink} ${utilsStyles.textSmall}`}
              data-testid={`coin-history-item-link-${item.id}`}
            >
              {item.customInfo.lotteryEventName}
            </Link>
          </div>
        </li>
      ))}
    </ul>
  );
}

export default CoinHistory;
